import { toast } from "react-toastify";

const parseFilenameFromDisposition = (disposition) => {
  if (!disposition) return null;
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match) {
    try { return decodeURIComponent(utf8Match[1]); } catch { /* ignore */ }
  }
  const quotedMatch = disposition.match(/filename="([^"]+)"/i);
  if (quotedMatch) return quotedMatch[1];
  const bareMatch = disposition.match(/filename=([^;]+)/i);
  if (bareMatch) return bareMatch[1].trim();
  return null;
};

const triggerBrowserDownload = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const extractErrorMessage = async (error) => {
  const data = error?.response?.data;
  if (!data) return "Export failed. Please try again.";
  if (typeof data === "string") return data;
  if (data?.error) return data.error;
  if (data instanceof Blob) {
    try {
      const text = await data.text();
      const parsed = JSON.parse(text);
      return parsed?.error || "Export failed. Please try again.";
    } catch {
      return "Export failed. Please try again.";
    }
  }
  return "Export failed. Please try again.";
};

/**
 * Calls an API function that returns a Blob (xlsx attachment) and triggers
 * a browser download. The API function MUST be configured to use
 * responseType "blob" (passed via the 5th arg of performRequest).
 */
export const downloadExcel = async (
  apiFn,
  params,
  fallbackFilename = "export.xlsx"
) => {
  try {
    const response = await apiFn(params);
    const filename =
      parseFilenameFromDisposition(response.headers?.["content-disposition"]) ||
      fallbackFilename;
    triggerBrowserDownload(response.data, filename);
    return true;
  } catch (error) {
    const message = await extractErrorMessage(error);
    toast.error(message, { position: "top-right", autoClose: 5000 });
    return false;
  }
};
